import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from "chart.js";
import { generateDynamicChartColors } from "../../utils/generateDynamicChartColors";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

interface DynamicBarChartProps {
  data: number[];
  labels: string[];
  dataTitle: string;
  seed: number;
}

export const DynamicBarChart: React.FC<DynamicBarChartProps> = ({
  data,
  labels,
  dataTitle,
  seed
}) => {
  const { backgroundColors, borderColors } = generateDynamicChartColors(
    data.length,
    seed
  );

  const datasets = data.map((value, idx) => ({
    label: labels[idx],
    data: [value],
    backgroundColor: backgroundColors[idx],
    borderColor: borderColors[idx],
    borderWidth: 1,
    xAxisID: "x"
  }));

  const barData = {
    labels: [dataTitle],
    datasets
  };

  const options = {
    plugins: {
      tooltip: {
        enabled: true
      },
      legend: {
        labels: {
          color: "white"
        }
      },
      datalabels: {
        color: "white",
        display: true,
        formatter: (value: any) => value,
        font: {
          weight: "bold" as "bold"
        }
      }
    },
    scales: {
      x: {
        ticks: {
          color: "white"
        },
        grid: {
          display: false
        }
      },
      y: {
        ticks: {
          color: "white"
        },
        grid: {
          color: "rgba(255,255,255,0.2)"
        }
      }
    },
    hover: {
      mode: undefined
    }
  };

  return <Bar data={barData} options={options} />;
};

export default DynamicBarChart;
